import { useState } from "react";
import { MapPin, Clock, Truck, ShieldCheck, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { RAPID_QUICK_ITEMS, checkRapidPincode, etaLabel } from "../../lib/rapidData";

const STATUS_STYLE = {
  "60min": "border-ib-lime/40 text-ib-lime bg-ib-lime/10",
  sameday: "border-ib-blue/40 text-ib-blue bg-ib-blue/10",
  soon: "border-ib-warning/40 text-ib-warning bg-ib-warning/10",
  invalid: "border-ib-negative/40 text-ib-negative bg-ib-negative/10",
};

export function RapidHero() {
  const [pin, setPin] = useState("");
  const [result, setResult] = useState(null);
  const check = (e) => { e.preventDefault(); setResult(checkRapidPincode(pin)); };

  return (
    <div className="glass rounded-2xl p-6 md:p-8 border border-ib-lime/20 relative overflow-hidden" data-testid="rapid-hero">
      <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-ib-lime/10 blur-[60px] pointer-events-none" />
      <div className="flex flex-wrap gap-2 mb-5">
        {[[Clock, "Open 8 am – 8 pm, all days"], [Truck, "Free delivery above ₹500"], [ShieldCheck, "Pay on delivery"]].map(([Icon, t]) => (
          <span key={t} className="inline-flex items-center gap-1.5 font-jetbrains text-[10px] text-ib-text-secondary px-2.5 py-1 rounded-full border border-ib-steel/30">
            <Icon className="w-3 h-3 text-ib-lime" /> {t}
          </span>
        ))}
      </div>
      <h3 className="font-outfit font-extrabold text-2xl sm:text-3xl text-ib-text tracking-tight">Your site never waits for material again.</h3>
      <p className="font-manrope text-sm md:text-base text-ib-text-secondary mt-3 max-w-xl">
        Cement, cut-length TMT, plywood, wires and fittings delivered in <span className="text-ib-lime font-semibold">60 minutes across Delhi NCR</span>. Genuine stock, pay on delivery.
      </p>

      <form onSubmit={check} className="mt-6 flex flex-col sm:flex-row gap-2 max-w-md" data-testid="rapid-pincode-form">
        <div className="relative flex-1">
          <MapPin className="w-4 h-4 text-ib-text-muted absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            data-testid="rapid-pincode-input"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))}
            inputMode="numeric"
            placeholder="Site pincode"
            className="w-full h-11 rounded-lg bg-ib-surface border border-ib-steel/40 pl-9 pr-3 font-jetbrains text-sm text-ib-text placeholder:text-ib-text-muted focus:outline-none focus:border-ib-lime"
          />
        </div>
        <button type="submit" data-testid="rapid-pincode-check" className="h-11 px-5 rounded-lg bg-ib-lime text-ib-bg font-outfit font-bold text-sm hover:bg-ib-lime/90 transition-colors inline-flex items-center justify-center gap-1.5">
          Check delivery <ArrowRight className="w-4 h-4" />
        </button>
      </form>
      {result && (
        <div data-testid="rapid-pincode-result" className={`mt-3 inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 font-manrope text-xs px-3 py-1.5 rounded-lg border ${STATUS_STYLE[result.status]}`}>
          {result.message}
          {result.status === "60min" && <span className="font-jetbrains">· at your site by {etaLabel(60)}</span>}
          {result.status === "soon" && <Link to="/marketplace" className="underline underline-offset-2">Open Bulk marketplace</Link>}
        </div>
      )}

      <div className="mt-6 flex flex-wrap gap-2">
        {RAPID_QUICK_ITEMS.map((item) => (
          <span key={item} className="font-jetbrains text-[10px] px-2.5 py-1 rounded-md bg-ib-bg/60 border border-ib-steel/20 text-ib-text-secondary">{item}</span>
        ))}
      </div>
    </div>
  );
}
